import { CircularProgress } from "@mui/material";
import React from "react";
import { Button } from "react-bootstrap";
import "./styles/PrimaryButton.css";

export default function PrimaryButton({
  title,
  className,
  startIcon: StartIcon,
  endIcon: EndIcon,
  isLoading,
  isRow,
  ...props
}) {
  return (
    <Button
      className={`primary-button sf-primary position-relative ${
        isLoading ? "loading-button-width" : ""
      } ${className ? className : ""}`}
      {...props}
      title={title}
    >
      <div className={`${isRow ? 'd-flex align-items-center justify-content-center' : ''}`}>
        {isLoading ? (
          <CircularProgress
            color="secondary"
            size={21}
            thickness={7}
            className={"mr-5 loading-spinner"}
            classes={{
              root: "text-white",
            }}
          />
        ) : null}
        {StartIcon ? <StartIcon className={`start-icon `} /> : null}
        {isRow && <p>{title}</p>}
      </div>
      {!isRow && <p>{title}</p>}      
    </Button>
  );
}
